import styled from 'styled-components';
import type {TicketStatus} from '../types/ticket';

const STATUS_BG: Record<TicketStatus, string> = {
	open: '#dbeafe',
	in_progress: '#fef9c3',
	waiting_on_customer: '#ffedd5',
	resolved: '#dcfce7',
	closed: '#f1f5f9',
};
const STATUS_TEXT: Record<TicketStatus, string> = {
	open: '#1e40af',
	in_progress: '#854d0e',
	waiting_on_customer: '#9a3412',
	resolved: '#166534',
	closed: '#475569',
};
const STATUS_DOT: Record<TicketStatus, string> = {
	open: '#3b82f6',
	in_progress: '#eab308',
	waiting_on_customer: '#f97316',
	resolved: '#22c55e',
	closed: '#64748b',
};
const STATUS_LABELS: Record<TicketStatus, string> = {
	open: 'Open',
	in_progress: 'In progress',
	waiting_on_customer: 'Waiting on customer',
	resolved: 'Resolved',
	closed: 'Closed',
};

const Badge = styled.span<{$status: TicketStatus}>`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 2px 10px;
	border-radius: ${p => p.theme.sys.size.borderradius['1']};
	${p => p.theme.sys.font?.detail?.['1']}
	font-weight: 500;
	background: ${p => STATUS_BG[p.$status]};
	color: ${p => STATUS_TEXT[p.$status]};
`;
const Dot = styled.span<{$status: TicketStatus}>`
	width: 6px;
	height: 6px;
	border-radius: 9999px;
	background: ${p => STATUS_DOT[p.$status]};
`;

interface Props {
	status: TicketStatus;
}

export function TicketStatusBadge({status}: Props) {
	return (
		<Badge $status={status}>
			<Dot $status={status} aria-hidden="true" />
			{STATUS_LABELS[status]}
		</Badge>
	);
}
